import { apiInstance, sciInstance } from 'common/utils/axios';

export const getUser = () => apiInstance.get('/users');

/** Perfil del usuario autenticado (nombre, rol, etc.) */
export const getMe = () => apiInstance.get('/users/me');

export const getEntity = () => sciInstance.get('/me/entity');

export const changePassword = request => sciInstance({
  method: 'PUT',
  url: '/user/change-password',
  data: request,
});
